import type { IAppSummary } from '~/types/application'

import config from '~/config'
import { request } from '~/utils/request'

/* @deprecated Use `~/api/application-management getAppsManagerList instead */
export const getAllApps = ({
  owned,
  page,
  platform,
  query,
  size,
}: {
  owned?: boolean
  page?: number
  platform?: string
  query?: string
  size?: number
}): Promise<IPaginatedResponse<IAppSummary>> => {
  return request({
    params: {
      owned: owned,
      p: page,
      platform: platform,
      q: query,
      size,
    },
    url: `${config.VERSIONS_API}/application/search`,
  })
}
